var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('figure',{staticClass:"bg-gray-100 rounded-xl p-8"},_vm._l((_vm.history),function(game,index){return _c('history-dislay',{key:index,attrs:{"game":game}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }